// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2IuUl","clinicsSelect":"TableHeading_clinicsSelect__2JYGE"};